import React from 'react';
import { Container } from 'react-bootstrap';
import { Routes, Route, Navigate } from 'react-router';

import AnswerTemplates from './AnswerTemplates';
import ProductCategoies from './ProductCategoies';
import AuthMarketplace from './AuthMarketplace';
import IntegrationDetail from './AuthMarketplace/IntegrationDetail';
import Goods from './Goods';
import Logs from './Logs';
import FeatureFlags from './FeatureFlags';
import Classifier from './Classifier/Classifier';
import DelayJobs from './DelayJobs';
import Brands from './Brands';
import VncClient from './VncClient';
import Notifications from './Notifications';
import MpSyncWatermarks from './MpSyncWatermarks';
import Tags from './Tags';
import Warehouses from './Warehouses';
import GoodsDetail from './GoodsDetail';

const Settings = () => {
  return (
    <Container>
      <Routes>
        <Route path="goods" element={<Goods />}></Route>
        <Route path="goods/:article" element={<GoodsDetail />}></Route>
        <Route path="answer_template" element={<AnswerTemplates />}></Route>
        <Route path="product_categories" element={<ProductCategoies />}></Route>
        <Route path="auth_marketplace" element={<AuthMarketplace />}></Route>
        <Route
          path="auth_marketplace/:marketplace"
          element={<IntegrationDetail />}
        ></Route>
        <Route path="logs" element={<Logs />}></Route>
        <Route path="features" element={<FeatureFlags />}></Route>
        <Route path="classifier" element={<Classifier />}></Route>
        <Route path="delay_jobs" element={<DelayJobs />}></Route>
        <Route path="brands" element={<Brands />}></Route>
        <Route path="tags" element={<Tags />}></Route>
        <Route path="warehouses" element={<Warehouses />}></Route>
        <Route
          path="mp_product_links"
          element={<Navigate to="/settings/auth_marketplace" replace />}
        ></Route>
        <Route path="vnc" element={<VncClient />}></Route>
        <Route path="notifications" element={<Notifications />}></Route>
        <Route path="mp_sync_watermarks" element={<MpSyncWatermarks />}></Route>
        <Route
          index
          element={<Navigate to="answer_template" replace />}
        ></Route>
        <Route
          path="*"
          element={<Navigate to="answer_template" replace />}
        ></Route>
      </Routes>
    </Container>
  );
};

export default Settings;
